import React from "react";
import styled from "styled-components";
import { Table } from "../../components/utils/Pagination/NumberedPagination/table";
import { FaTrash, FaEdit } from "react-icons/fa";
import { Link } from "../../components/pages/utils";
import { fmtDateToLocalZone } from "../../utils";
import ActionConfirmationButton from "../../components/pages/CourseAuthor/ActionConfirmation";
import { fixedSize } from "../Themes/ThemesList.content";
import { IUserInfo } from "../types/common";

interface UsersListProps {
  usersInfo: IUserInfo[];
  deleteUser: (accountId: string) => void;
}

const AccountName = styled.div`
  margin: 0 1rem 0 0;
`;

export const UsersList = (props: UsersListProps): JSX.Element => {
  const { usersInfo, deleteUser } = props;

  const removeUser = (accountId: string) => () => deleteUser(accountId);

  const toTableUsers = (userInfo: IUserInfo) => {
    const userId = userInfo.accountId.replace("acc.", "");
    return {
      actions: (
        <ActionConfirmationButton action="Delete" actionFn={removeUser(userInfo.accountId)} ActionIcon={FaTrash} />
      ),
      createdAt: fmtDateToLocalZone(userInfo.createdAt),
      displayName: (
        <Link to={`/account-management/${userId}`}>
          <AccountName>{userInfo.displayName}</AccountName>
          <FaEdit style={{ minWidth: "1em", alignSelf: "center" }} data-testid={"edit-icon"} />
        </Link>
      ),
      lastEdited: fmtDateToLocalZone(userInfo.lastEdited),
      lastEditorName: userInfo.lastEditorName,
    };
  };

  return (
    <Table
      columns={[
        { accessor: "displayName", name: "Account Name" },
        { accessor: "createdAt", name: "Date Created" },
        { accessor: "lastEdited", name: "Last Edited" },
        { accessor: "lastEditorName", name: "Last Edited By" },
        { accessor: "actions", name: "Actions", styles: fixedSize },
      ]}
      data={usersInfo.map(toTableUsers)}
      emptyDataMessage="No accounts found."
    />
  );
};
